import React, { useState } from "react";
import PropTypes from "prop-types";
import { createUseStyles } from "react-jss";
import { useDropzone } from "react-dropzone";
import i18n from "../../../../utils/locale/i18n";
import reactDropzoneSkin from "../../../style/common/input-type/react-dropzone.skin";

const useStyles = createUseStyles(reactDropzoneSkin);

const UploadDropzoneOne = ({ onFilesChange }) => {
  const [acceptedFiles, setAcceptedFiles] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");

  const classes = useStyles();

  const setFiles = (files) => {
    setAcceptedFiles(files);
    setErrorMessage("");
    onFilesChange(files);
  };

  const onDrop = (newAcceptedFiles) => {
    if (newAcceptedFiles.length > 1) {
      setErrorMessage(i18n.t("upload_error_only_one_file"));
    } else {
      setFiles([...acceptedFiles, ...newAcceptedFiles]);
    }
  };

  const removeFile = (fileToRemove) => {
    const updatedFiles = acceptedFiles.filter((file) => file !== fileToRemove);
    setFiles(updatedFiles);
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
  });

  return (
    <div className={classes["dropzone-container"]}>
      {acceptedFiles.length === 0 && (
        <div {...getRootProps({ className: classes.dropzone })}>
          <input {...getInputProps()} />
          <span>{i18n.t("drag_n_drop_file_one")}</span>
        </div>
      )}
      {errorMessage && (
        <div className="alert alert-danger" role="alert">
          {errorMessage}
        </div>
      )}
      {acceptedFiles.length > 0 && (
        <>
          {acceptedFiles.map((file) => (
            <div key={file.name}>
              {file.name} &nbsp;
              <button
                className="btn btn-default btn-outline-dark"
                type="button"
                onClick={() => removeFile(file)}
              >
                {i18n.t("remove_file")}
              </button>
            </div>
          ))}
        </>
      )}
    </div>
  );
};

UploadDropzoneOne.propTypes = {
  onFilesChange: PropTypes.func.isRequired,
};

export default UploadDropzoneOne;
